import { getAPIUrl } from '../helpers/App';

export const APIgetSettings = () => (
  window.axios.get(getAPIUrl('/settings'))
    .then(response => (response))
);

export const APIupdateSettings = settings => (
  window.axios.patch(getAPIUrl('/settings'), { settings })
    .then(response => (response))
);

export const APIgetWatermarkPreview = (watermarkUrl, position) => {
  let path = watermarkUrl;
  if (path && path.indexOf('http') === 0) {
    path = new URL(path).pathname;
  }
  return window.axios.get(getAPIUrl('/watermark_preview'), { params: { path, position } })
    .then(response => (response));
};
